import React from 'react'
import { Button } from '@mui/material'

const PURPLE_BUTTON_STYLE = {
  backgroundColor: '#7C3AED',
  '&:hover': {
    backgroundColor: '#6D28D9',
  },
}

interface AIPurpleButtonProps {
  className?: string
  onClick: React.MouseEventHandler<HTMLButtonElement>
  disabled: boolean
  children: React.ReactNode
}

export const AIPurpleButton = ({ onClick, disabled, children, className }: AIPurpleButtonProps) => (
  <Button
    variant="contained"
    onClick={onClick}
    disabled={disabled}
    className={className}
    sx={PURPLE_BUTTON_STYLE}
  >
    {children}
  </Button>
)
